import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext} from "react";
import {handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import MDInput from "../../components/MDInput";

export default function ManageReleaseModal({release, show, saving, handleClose, handleSave}) {

  const [context, setContext] = useContext(AppContext);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(release)
  });

  return (
    <Modal onHide={handleClose} size={'lg'} show={show}>
      <form
        onSubmit={handleSubmit(handleSave)} id={'memberForm'}>
        <Modal.Header closeButton>
          <Modal.Title>{release?.guid ? 'Edit' : 'Add'} Release</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <MDInput
                        variant="outlined" type="text"
                        {...register('name')}
                        placeholder="Enter Version Title ie v.1.15.0"
                        autoComplete="off"
                        InputLabelProps={{shrink: true}}
                        className="form-control" id="name"
                        label="Version Title"/>

                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group mt-4">

                      <MDInput
                        variant="outlined" type="text"
                        {...register('description')}
                        placeholder="Enter Version Description"
                        autoComplete="off"
                        InputLabelProps={{shrink: true}}
                        className="form-control" id="description"
                        label="Release Description"/>
                    </div>
                  </Col>
                </Row>
                <Row className={'mt-2'}>
                  <Col className={'col'} sm={6} xs={12}>

                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={saving}>
            {saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}